export const getSelectedPageLinkStyles = (selected, pageNo, isLength) => {
        const baseMargin = pageNo >=1000 ? '3px' : pageNo > 99 ? '7px' : '5px';
        return {
            borderRadius: isLength > 2 ? '50%' : '20px',
            marginLeft: baseMargin,
            marginRight: baseMargin,
            cursor: 'pointer',
            width: isLength > 2 ? '40px' : '22px',
            height: isLength > 2 ? '27px' : '22px',
            textAlign: 'center',
            fontSize: '14px',
            border: selected
                ? '1px solid black' 
                : '',
            background: selected
                ? 'darkgray 0% 0% no-repeat padding-box'
                : '',
            opacity: selected ? 1 : '',
            color: selected ? 'white' : '',
            marginBottom: '10px',
            paddingTop: isLength > 2 ? '2px' : '',
        };
    };